import { normalizeValue } from './ValueNormalizer';

export const PlateType = [
  'Dealer',
  'Transit',
  'Commercial',
  'Temporary',
  'Apportioned',
  'Farm',
  'Personal/Private',
] as const;

export const normalizePlateType = (
  plateType?: string | null,
): string | undefined => {
  return normalizeValue(PlateType, plateType);
};
